export const Types = {
  //Get - List
  GET_SUPPLIERS_LIST_REQUEST: 'GET_SUPPLIERS_LIST_REQUEST',
  GET_SUPPLIERS_LIST_SUCCESS: 'GET_SUPPLIERS_LIST_SUCCESS',
  GET_SUPPLIERS_LIST_FAIL: 'GET_SUPPLIERS_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_SUPPLIERS_LIST: 'SET_UPDATE_SUPPLIERS_LIST',

  //Store - Add
  POST_SUPPLIERS_ADD_REQUEST: 'POST_SUPPLIERS_ADD_REQUEST',
  POST_SUPPLIERS_ADD_SUCCESS: 'POST_SUPPLIERS_ADD_SUCCESS',
  POST_SUPPLIERS_ADD_FAIL: 'POST_SUPPLIERS_ADD_FAIL',

  //Update - Edit
  PUT_SUPPLIERS_EDIT_REQUEST: 'PUT_SUPPLIERS_EDIT_REQUEST',
  PUT_SUPPLIERS_EDIT_SUCCESS: 'PUT_SUPPLIERS_EDIT_SUCCESS',
  PUT_SUPPLIERS_EDIT_FAIL: 'PUT_SUPPLIERS_EDIT_FAIL',

  //Delete
  DELETE_SUPPLIERS_DEL_REQUEST: 'DELETE_SUPPLIERS_DEL_REQUEST',
  DELETE_SUPPLIERS_DEL_SUCCESS: 'DELETE_SUPPLIERS_DEL_SUCCESS',
  DELETE_SUPPLIERS_DEL_FAIL: 'DELETE_SUPPLIERS_DEL_FAIL',


  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {
  dataList: [],
  loadingList: false,
  errorList: false,
  errorDataList: false,
  dataListUpdate: false,

  loadingAdd: false,
  errorAdd: false,
  errorDataAdd: false,

  loadingEdit: false,
  errorEdit: false,
  errorDataEdit: false,

  loadingDelete: false,
  errorDelete: false,
  errorDataDelete: false,

};

export default function suppliers(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Get - List
    case Types.GET_SUPPLIERS_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        errorList: false,
      };
    case Types.GET_SUPPLIERS_LIST_SUCCESS:
      return {
        ...state,
        dataList: action.payload,
        loadingList: false,
        errorList: false,
        errorDataList: false
      };
    case Types.GET_SUPPLIERS_LIST_FAIL:
      return {
        ...state,
        dataList: false,
        loadingList: false,
        errorList: true,
        errorDataList: action.payload,
      };

    case Types.SET_UPDATE_SUPPLIERS_LIST:
      return {
        ...state,
        dataListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_SUPPLIERS_ADD_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: false,
      };
    case Types.POST_SUPPLIERS_ADD_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,
      };
    case Types.POST_SUPPLIERS_ADD_FAIL:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: true,
        errorDataAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_SUPPLIERS_EDIT_REQUEST:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: false,
      };
    case Types.PUT_SUPPLIERS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,
      };
    case Types.PUT_SUPPLIERS_EDIT_FAIL:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: true,
        errorDataEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_SUPPLIERS_DEL_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: false,
      };
    case Types.DELETE_SUPPLIERS_DEL_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,
      };
    case Types.DELETE_SUPPLIERS_DEL_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: true,
        errorDataDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        dataList: false,
        loadingList: false,
        errorList: false,
        errorDataList: false,
        dataListUpdate: false,

        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,

        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,

        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  //Get - List
  getSuppliersListRequest: (payload) => ({
    type: Types.GET_SUPPLIERS_LIST_REQUEST,
    payload,
  }),
  getSuppliersListRequestSuccess: (payload) => ({
    type: Types.GET_SUPPLIERS_LIST_SUCCESS,
    payload,
  }),
  getSuppliersListRequestFail: (payload) => ({
    type: Types.GET_SUPPLIERS_LIST_FAIL,
    payload,
  }),

  setUpdateSuppliers: (payload) => ({
    type: Types.SET_UPDATE_SUPPLIERS_LIST,
    payload,
  }),


  //Store - Add 
  postSuppliersAddRequest: (payload) => ({
    type: Types.POST_SUPPLIERS_ADD_REQUEST,
    payload,
  }),
  postSuppliersAddRequestSuccess: () => ({
    type: Types.POST_SUPPLIERS_ADD_SUCCESS,
  }),
  postSuppliersAddRequestFail: (payload) => ({
    type: Types.POST_SUPPLIERS_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putSuppliersEditRequest: (payload) => ({
    type: Types.PUT_SUPPLIERS_EDIT_REQUEST,
    payload,
  }),
  putSuppliersEditRequestSuccess: () => ({
    type: Types.PUT_SUPPLIERS_EDIT_SUCCESS,
  }),
  putSuppliersEditRequestFail: (payload) => ({
    type: Types.PUT_SUPPLIERS_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteSuppliersDelRequest: (payload) => ({
    type: Types.DELETE_SUPPLIERS_DEL_REQUEST,
    payload,
  }),
  deleteSuppliersDelRequestSuccess: () => ({
    type: Types.DELETE_SUPPLIERS_DEL_SUCCESS,
  }),
  deleteSuppliersDelRequestFail: (payload) => ({
    type: Types.DELETE_SUPPLIERS_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
